<template>
  <div>
    <breadcrumbs :data="list_breadcrumbs"></breadcrumbs>
    <form class="section" @submit.prevent="submitData">
      <div class="field">
        <label class="label">EDC Number</label>
        <div class="control">
          <input v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('edc_number')}" name="edc_number" type="text" v-model="edc_number">
        </div>
        <span class="help is-danger" v-show="errors.has('edc_number')" v-text="errors.first('edc_number')"></span>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button class="button is-link" type="submit">Submit</button>
        </div>
        <div class="control">
          <button class="button is-danger" type="button" @click="getModalConfirmation('Cancel', 'Are you sure want to cancel?', 'link_back')">Cancel</button>
        </div>
      </div>
    </form>
    <confirmation-modal :data-modal="modal_confirmation_data" @confirm-event="executeModalAction"></confirmation-modal>
  </div>
</template>

<script>
import {ModalConfirmation} from '@/library/mixins/local/ModalConfirmation'
export default {
  mixins: [ModalConfirmation],
  data () {
    return {
      list_breadcrumbs: [
        {
          title: 'EDC',
          path: '/panel/edc'
        },
        {
          title: 'Update',
          path: ''
        }
      ],
      show_data: {
        1: 'Show',
        0: 'Hide'
      },
      id: '',
      edc_number: '',
      show: 1
    }
  },
  created () {
    if (this.getSessionItem('id_token') === null || this.getSessionItem('access_token') === null) {
      this.$router.push('/panel/logout')
    }
    var self = this
    this.id = this.$route.params.id
    self.$geb.emit({id: 'preloader', eventData: true})
    this.flyPostSession('edc/detail', {
      id: this.id
    })
    .then(function (response) {
      if (response.data.response_code === 1) {
        self.edc_number = response.data.data.edc_number
      } else if (response.data.response_code === -1) {
        self.removeSessionItem('id_token')
        self.removeSessionItem('access_token')
        self.$router.push('/')
      } else {
        console.log(response.data.message)
      }
      self.$geb.emit({id: 'preloader', eventData: false})
    })
    .catch(function (response) {
      self.errorMessage(response)
      self.$geb.emit({id: 'preloader', eventData: false})
    })
  },
  methods: {
    submitData () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      this.flyPostSession('edc/update', {
        id: this.id,
        edc_number: this.edc_number
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.$router.push('/panel/edc')
        } else if (response.data.response_code === -1) {
          self.removeSessionItem('id_token')
          self.removeSessionItem('access_token')
          self.$router.push('/')
        } else {
          var result = response.data.message
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    executeModalAction (confirmData) {
      if (confirmData.label === 'link_back') {
        if (confirmData.flag === true) {
          this.$router.push('/panel/edc')
        }
      }

      this.clearModalConfirmationData()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/panel/edc/Update.vue